import React from 'react';
import Inc from './include.js';
import './top.scss';

class TopPage extends React.Component {
	constructor(props){
		super(props);

		this.state = {
		};
	}
	componentDidMount (){
		//setTimeout( function(){
		//	alert("10s");
		//},10000);
	}
	render (){
		let config = "second";
		if( process.env.REACT_APP_RUNMODE!=="DEV" ){
			config += " hide";
		}
		const lv1 = "fas fa-fw fa-" + Inc.LV_FIGURES[0];
		const lv2 = "fas fa-fw fa-" + Inc.LV_FIGURES[1];
		const lv3 = "fas fa-fw fa-" + Inc.LV_FIGURES[2];
		return (
			<div id="top">
				<div className="ver">ver.190404</div>
				<div className="plate">
					<div className="mark">
						<i className="fas fa-moon"></i>
					</div>
					<div className="title">
						<h1>夜空のコリー</h1>
						<div className="serial">retro-ink17 : 06/12</div>
					</div>
					<div className="menu">
						<button
							onClick={()=>this.goIntro(1)}
						><i className={lv1}></i> 初級</button><br/>
						<button
							onClick={()=>this.goIntro(2)}
						><i className={lv2}></i> 中級</button><br/>
						<button
							onClick={()=>this.goIntro(3)}
						><i className={lv3}></i> 上級</button><br/>
						<button
							onClick={()=>this.props.openBook()}
							className="second"
						><i className="fas fa-book fa-fw"></i> 遊び方</button><br/>
						<button
							className={config}
							onClick={()=>this.config()}
						>初期化</button>
					</div>
					<div className="credit">
						<a href="https://goisagi.retro-ink.com/" rel="noopener noreferrer"><i className="fas fa-copyright"></i>レトロインク 2019</a>
					</div>
				</div>
			</div>
		)
	}
	goIntro (level){
		const play = {lv:level};
		this.props.setState({mode:"intro",play:play});
	}
	goRanking (){

	}
	config (){
		this.props.showLoading(true);
		this.props.ajax("config",{},(res)=>{
			this.props.showLoading(false);
			if( res.ok ){
				this.updateLatest();
				//console.log("complete!");
			}
		});
	}

}

export default TopPage;